import { AUTH_FAILED } from '../actions/types';

const requestMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  const { payload } = action;
  switch (payload?.status) {
    case 401:
      store.dispatch({ type: AUTH_FAILED });
      break;
    case 403:
      // handle 403
      break;

    case 503:
      // handle 503
      break;

    default:
      break;
  }

  return result;
};

export default requestMiddleware;
